import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login';
import UiComponents from '../views/DrsComponents';
import Dashboard from '../views/Dashboard';
import Location from '../views/Location';
//import Device from '../views/Device';
import Register from '../views/Register';
import Remember from '../views/Remember';
import Recover from '../views/Recover';
import Verify from '../views/Verify';

Vue.use(VueRouter);

const routes = [
    {
        path: '/register',
        name: 'Register',
        component: Register,
    },
    {
        path: '/remember',
        name: 'Remember',
        component: Remember,
    },
    {
        path: '/recover',
        name: 'Recover',
        component: Recover,
    },
    {
        path: '/authorize',
        name: 'Authorize',
        component: Login,
    },
    {
        path: '/verify',
        name: 'Verify',
        component: Verify,
        props: true,
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
    },
    {
        path: '/components',
        name: 'UiComponents',
        component: UiComponents,
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
    },
    {
        path: '/location/:id',
        name: 'Location',
        component: Location,
        props: true,
    },
    // {
    //     path: '/location/:id/installation/:installation_ref/',
    //     name: 'Installation',
    //     component: Location,
    //     props: true,
    // },
    // {
    //     path: '/location/:id/installation/:installation_ref/device/:device_ref',
    //     name: 'Device',
    //     component: Location,
    //     props: true,
    // },
    //{
    //    path: '/about',
    //    name: 'About',
    //    // route level code-splitting
    //    // this generates a separate chunk (about.[hash].js) for this route
    //    // which is lazy-loaded when the route is visited.
    //    component: function() {
    //        return import(/* webpackChunkName: "about" */ '../views/About');
    //    },
    //},
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

router.getFullRoute = (route) => `${window.location.origin}${router.resolve(route).href}`;

export default router;
